import React from 'react';
import { captureSentryException } from '../../helpers/jsHelper';
import { SENTRY_ERROR_TYPES } from '../../constants/constants';
// import { ImagineLogo } from '../../assets/icons';
import { LOGIN_HOME } from '../../constants/routePathConstants';
import { BigButton } from '../../common';
//import { captureException } from '@sentry/react';
import ImagineLogo from '../../assets/images/imagine-logo-black-text.png';

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "#f8f9fa",
    textAlign: "center",
  },
  content: {
    padding: "40px",
    // background: "#fff",
    borderRadius: "12px",
    // boxShadow: "0px 6px 15px rgba(0, 0, 0, 0.1)",
  },
  image: {
    width: "300px",
    marginBottom: "30px",
  },
  heading: {
    fontSize: "30px",
    fontWeight: "bold",
    color: "#333",
    marginBottom: "10px",
  },
  message: {
    fontSize: "18px",
    color: "#555",
    marginBottom: "20px",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "center",
    gap: "15px",
  },
  button: {
    padding: "12px 20px",
    borderRadius: "6px",
    border: "none",
    cursor: "pointer",
    transition: "0.3s",
    height: "45px"
  },
};

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // TODO: discuss implementing sentry for errors tracking
    // You can also log the error to an error reporting service
    captureSentryException(
      { type: 'CATCH_EXCEPTION', error },
      {
        tags: {
          issue_type: SENTRY_ERROR_TYPES.ERROR,
        },
      }
    );
  }

  reloadPage = () => {
    window.location.reload();
  };

  render() {
    const { hasError } = this.state;

    if (hasError) {
      return (
        <div style={styles.container}>
        <div style={styles.content}>
          <img src={ImagineLogo} style={styles.image} />
          {/* // <ImagineLogo style={styles.image}/> */}
          <h1 style={styles.heading}>{`Uh-oh! Something’s not right`}</h1>
          <p style={styles.message}>
            Our system had a hiccup. You can reload the page or return to the login screen to start fresh.
          </p>
          <div className={styles.btnText} style={styles.buttonContainer}>
            <BigButton className="errorBtn bigButton lf-btn-1" style={styles.button} onClick={this.reloadPage}>Reload Page</BigButton>
            <BigButton className="errorBtn bigButton lf-btn-1" style={styles.button} onClick={() => (window.location.href = LOGIN_HOME)}>
              Go to Login
            </BigButton>
          </div>
        </div>
      </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
